<template>
  <el-form
    ref="form"
    :model="form"
  >
    <LicenseRenderer
      licenseName="submission"
      @input="updateCheckBox"
      :form="{
        mediaRightsPerFilm: {
          value: form.rights_media,
          disabled: !getEditability(value.rights_media),
        },
        thirdParty: {
          value: form.rights_general,
          disabled: !getEditability(value.rights_general),

        },
        monetisation: {
          value: form.rights_third_party_and_monetization,
          disabled: !getEditability(value.rights_third_party_and_monetization),
        },
        labs: {
          value: form.rights_labs,
          disabled: !getEditability(value.rights_labs), 
        },  
        additionalAgreementsForm: {
          value: form.additional_agreements,
        },
      }"
    />

  </el-form>
</template>

<script>
import SUBMISSION_STATUS from '@/assets/data/viddsee/submissionStatus';
import LicenseRenderer from '@/components/Licenses/CommonLicenseComponents/LicenseRenderer';
import { isUpgrading } from '@/helpers/submissionValueHelper';
import stepMixin from '../Mixins/stepMixin';

export default {
  name: 'terms',
  mixins: [
    stepMixin,
  ],
  components: {
    LicenseRenderer,
  },
  props: {
    value: {},
  },
  data() {
    return {};
  },
  computed: {
    form() {
      return {
        rights_media: this.value.rights_media,
        rights_general: this.value.rights_general,
        additional_agreements: this.value.additional_agreements,
        rights_third_party_and_monetization: this.value.rights_third_party_and_monetization,
        rights_labs: this.value.rights_labs,
      };
    },
    isStatusIncomplete() {
      const status = this.$store.state.submission[this.value.id].status;
      return SUBMISSION_STATUS.TYPE[status] === SUBMISSION_STATUS.TYPE.incomplete;
    },
  },
  methods: {
    updateCheckBox([prop, value]) {
      if (this.isStatusIncomplete) {
        this.$emit('input', {
          [prop]: value,
        });
      } else if (isUpgrading(value, this.form[prop])) {
        this.$confirm(null, 'Are you sure?', {
          confirmButtonText: 'Agree',
          cancelButtonText: 'Back',
          message: 'You are about to accept this agreement. Press Agree to confirm your action.',
        })
          .then(() => {
            this.$emit('input', {
              [prop]: value,
            });
          })
          .catch(() => {});
      }
    },
    updateForm() {
      this.$emit('input', this.form);
    },
    getEditability(value) {
      // Rights can be checked or unchecked during `incomplete` status
      if (this.isStatusIncomplete) return true;
      // Once submitted, it can only be updated if it was previously unchecked.
      // I.e. user will not be able to untick this anymore once ticked.
      else if (
        (value === 0) ||
        (value == null) ||
        (value === '') ||
        (value === false)
      ) return true;
      // Otherwise, user cannot update the rights anymore
      else return false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Submission/steps/Terms.vue